import PriceOfferStatusIcon from 'components/tables/data/price-offer/PriceOfferStatusIcon';
import { PriceOfferRow } from 'components/tables/data/price-offer/types';

/**
 * Column for the price offer status.
 */
export default function StatusColumn({ data }: { data: PriceOfferRow }) {
  return <PriceOfferStatusIcon status={data.status} />;
}
